import { TextLink, Title } from "@abb/arcadia-ui-react"
import { useCallback } from "react"
import { copyToClipboard } from "../utils/copyToClipboard"
import { BackToURL } from "./BackToURL"

export interface DiMaDetailsHeaderProps {
  readonly url: string
  readonly title: string
  readonly label: string
  readonly subtitle: string
  readonly hideCopyToClipboard?: boolean
}

export function DiMaDetailsHeader(props: DiMaDetailsHeaderProps) {
  const { url, title, label, subtitle, hideCopyToClipboard = false } = props

  const copyToClipboardSubtitle = useCallback(() => {
    copyToClipboard(subtitle)
  }, [subtitle])

  return (
    <div
      className="title-with-show-back-button"
      style={{ marginTop: "24px", marginBottom: "24px" }}
    >
      <div className="title-info-container">
        <div className="previous-label-container">
          <BackToURL url={url} />
        </div>
        <Title textElement={<div className="title">{title}</div>} />
        <div className="separator-line" />
        <div className="with-text-link">
          <TextLink
            //leadingIconName="icon_abb_dias icon-abb_copy-1"
            parentClassName="mb-4"
            size={16}
            text={label}
            onClick={copyToClipboardSubtitle}
            disabled={hideCopyToClipboard}
          />
        </div>
      </div>
    </div>
  )
}
